// loading.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private pendingRequests = 0;

  loading$ = this.loadingSubject.asObservable();

  show(): void {
    this.pendingRequests++;
    if (this.pendingRequests === 1) {
      this.loadingSubject.next(true);
    }
  }

  hide(): void {
    if (this.pendingRequests === 0) return;

    this.pendingRequests--;
    if (this.pendingRequests === 0) {
      this.loadingSubject.next(false);
    }
  }
}
